export default {
  models: [],
  siteConfig: {}
}
